import { create } from 'zustand';

interface OrgMembership {
  org_id: string;
  org_name: string;
  role: string;
}

interface OrgState {
  currentOrgId: string | null;
  currentOrgName: string | null;
  organizations: OrgMembership[];
  setCurrentOrg: (id: string, name: string) => void;
  setOrganizations: (orgs: OrgMembership[]) => void;
  clear: () => void;
}

function readStorage(key: string) {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(key);
}

function writeStorage(key: string, value: string) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(key, value);
}

function removeStorage(key: string) {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(key);
}

export const useOrgStore = create<OrgState>((set) => ({
  currentOrgId: readStorage('currentOrgId'),
  currentOrgName: readStorage('currentOrgName'),
  organizations: [],
  setCurrentOrg: (id, name) => {
    writeStorage('currentOrgId', id);
    writeStorage('currentOrgName', name);
    set({ currentOrgId: id, currentOrgName: name });
  },
  setOrganizations: (orgs) => {
    set({ organizations: orgs });
    const stored = readStorage('currentOrgId');
    if (orgs.length > 0 && !stored) {
      writeStorage('currentOrgId', orgs[0].org_id);
      writeStorage('currentOrgName', orgs[0].org_name);
      set({ currentOrgId: orgs[0].org_id, currentOrgName: orgs[0].org_name });
    }
  },
  clear: () => {
    removeStorage('currentOrgId');
    removeStorage('currentOrgName');
    set({ currentOrgId: null, currentOrgName: null, organizations: [] });
  },
}));
